<script>
	export default {
		name: 'LogExecuter',
		data() {
			return {
				color_: {
					debug: '#4caf50',
					info: '#2196f3',
					warning: '#fb8c00',
					error: '#ff5252',
					fatal: '#6200ea',
					dev: '#666666'
				}
			}
		},
		methods: {
			logDev(title, text, debug) { // only logged on local log mode
				const self_ = this;
				if(self_.logLevel.dev) {
					self_.$_logExec_logLocal('dev', title, text, debug)
				}
			},
			logDebug(title, text, debug) {
				const self_ = this;
				if(self_.logLevel.debug) {
					self_.$_logExec_log('debug', title, text, debug)
				}
			},
			logInfo(title, text) {
				const self_ = this;
				if(self_.logLevel.info) {
					self_.$_logExec_log('info', title, text, null)
				}
			},
			logWarning(title, text) {
				const self_ = this;
				if(self_.logLevel.warning) {
					self_.$_logExec_log('warning', title, text, null)
				}
			},
			logError(title, text, debug) {
				const self_ = this;
				if(self_.logLevel.error) {
					self_.$_logExec_log('error', title, text, debug)
				}
			},
			logFatal(title, text) {
				const self_ = this;
				self_.$_logExec_log('fatal', title, text, null)
			},
			$_logExec_log(level, title, text, debug) {
				const self_ = this;

				self_.$_logExec_logLocal(level, title, text, debug)
				self_.$_logExec_logServer(level, title, text, debug)
			},
			$_logExec_logLocal(level, title, text, debug) {
				const self_ = this;

				const local_ = self_.getLocalStorage('logModeLocal')

				if(!self_.logMode.local && !local_) { return }

				// millisecond
				const now_ = new Date()
				const created_ = self_.getAppState('createdDatetime')
				const msNow_ = self_.formatDate(now_, 'x')
				const msCreated_ = self_.formatDate(created_, 'x')
				const ms_ = msNow_ - msCreated_;
				// text
				if(!self_.isEmpty(text)) {
					const log_ = '/* ' + level + ':' + ms_ + ' */ [' + title + '] ' + text;
					console.log('%c' + log_, 'color: ' + self_.color_[level])
				}
				// debug
				if(self_.isObject(debug)) {
					const debug_ = '/* ' + level + ':' + ms_ + ' */ [' + title + '] ' + JSON.stringify(debug);
					console.log('%c' + debug_, 'color: ' + self_.color_[level])
				}
			},
			$_logExec_logServer(logLevel, logTitle, logText, logDebug) {
				const self_ = this;

				const server_ = self_.getLocalStorage('logModeServer')

				if(!self_.logMode.server && !server_) { return }

				// datetime
				const datetime_ = self_.formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss')
				const created_ = self_.getAppState('createdDatetime')
				const msDatetime_ = self_.formatDate(datetime_, 'x')
				const msCreated_ = self_.formatDate(created_, 'x')
				const millisecond_ = msDatetime_ - msCreated_;
				// uid
				let uid_ = null;
				if (self_.firebase.apps.length == 0 || self_.isFalse(self_.getCurrentUser('uid'))) { uid_ = 'nonUser' }
				else { uid_ = self_.getCurrentUser('uid') }
				// app
				let appEnv_ = null;
				if(self_.env.dev) { appEnv_ = 'dev'; }
				else if(self_.env.release) { appEnv_ = 'release'; }
				else if(self_.env.qa) { appEnv_ = 'qa'; }
				const appSessionId_ = self_.getCookie('appSessionId')
				const appPath_ = window.location.pathname;
				const appVersion_ = self_.appVersion;
				const appLanguage_ = self_.getAppState('language');
				const appTheme_ = self_.getAppState('theme');
				let appScreen_ = null;
				if(self_.getAppState('isMobileScreen')) { appScreen_ = 'mobile'; }
				else { appScreen_ = 'web'; }
				const appScreenWidth_ = self_.getAppState('screenWidth');
				const appScreenHeight_ = self_.getAppState('screenHeight');
				// browser
				const browserName_ = window.navigator.appName;
				const browserVersion_ = window.navigator.appVersion;
				const browserLanguage_ = window.navigator.language;
				const browserPlatform_ = window.navigator.platform;
				const browserUserAgent_ = window.navigator.userAgent;
				// location
				let locationLatitude_ = null;
				let locationLongitude_ = null;
				if(window.navigator.geolocation) {
					Promise.resolve().then(() => {
						return window.navigator.geolocation.getCurrentPosition()
					}).then(result => {
						locationLatitude_ = result.coords.latitude;
						locationLongitude_ = result.coords.longitude;
					}).catch(error => {
						locationLatitude_ = 'error';
						locationLongitude_ = 'error';
					})
				}

				self_.ipCliStoreAppLogs(datetime_, created_, millisecond_, uid_, logLevel, logTitle, logText, logDebug, appEnv_, appSessionId_, appPath_, appVersion_, appLanguage_, appTheme_, appScreen_, appScreenWidth_, appScreenHeight_, browserName_, browserVersion_, browserLanguage_, browserPlatform_, browserUserAgent_, locationLatitude_, locationLongitude_)
			}
		}
	}
</script>